import { render, staticRenderFns } from "./ButtonWithImage.vue?vue&type=template&id=2f9c0004&scoped=true&"
import script from "./ButtonWithImage.vue?vue&type=script&lang=js&"
export * from "./ButtonWithImage.vue?vue&type=script&lang=js&"
import style0 from "./ButtonWithImage.vue?vue&type=style&index=0&id=2f9c0004&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9c0004",
  null
  
)

export default component.exports